import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
    templateUrl: './not-registered.component.html',
    styleUrls: ['./not-registered.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
    ],

    providers: [
    ]
})
export class NotRegisteredComponent implements OnInit {
    private authService = inject(AuthService);
    private route = inject(ActivatedRoute);

    userEmail: string = '';
    reason: string = 'not-registered';
    title: string = 'Account Not Registered';
    message: string = 'You have successfully authenticated with Okta, but your account is not registered in this system.';
    actionMessage: string = 'Please contact your administrator to have your account created and assigned the appropriate roles, permissions, and tenants.';

    constructor() {
        //
    }

    async ngOnInit(): Promise<void> {
        const user = await this.authService.getUser();
        this.userEmail = user?.email ?? 'Unknown';

        // Check for reason parameter
        this.route.queryParams.subscribe(params => {
            this.reason = params['reason'] || 'not-registered';
            this.setMessagesByReason();
        });
    }

    private setMessagesByReason(): void {
        switch (this.reason) {
            case 'no-tenants':
                this.title = 'No Tenants Assigned';
                this.message = 'You have successfully authenticated with Okta, but your account has not been assigned to any tenants.';
                this.actionMessage = 'Please contact your administrator to have your account assigned to one or more tenants.';
                break;
            case 'no-roles':
                this.title = 'No Roles Assigned';
                this.message = 'You have successfully authenticated with Okta, but your account has not been assigned any roles.';
                this.actionMessage = 'Please contact your administrator to have your account assigned the appropriate roles and permissions.';
                break;
            case 'not-registered':
            default:
                this.title = 'Account Not Registered';
                this.message = 'You have successfully authenticated with Okta, but your account is not registered in this system.';
                this.actionMessage = 'Please contact your administrator to have your account created and assigned the appropriate roles, permissions, and tenants.';
                break;
        }
    }

    async signOut(): Promise<void> {
        await this.authService.signOut();
    }
}
